/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import React, { Suspense } from "react";
import { Redirect, Route } from "react-router-dom";
import { getLSAuth } from "../utilities/utils";
import { routes } from "../utilities/routes";
import { DATA_DICTIONARY_NAME } from "../../app/Constants/Constants";

export function PrivateRoute({ component: Component, ...rest }) {
  /* istanbul ignore next */
  const auth = getLSAuth();
  /* istanbul ignore next */
  return (
    <Route
      {...rest}
      render={
        (props) /* istanbul ignore next */ => {
          const pathname = props.location.pathname;
          const urlName = pathname.split("/")[1];
          const urlDeepLink = pathname.split("/")[2];
          const urlExtend = props.location.search
            ? `?redirect=${pathname}${props.location.search}`
            : `?redirect=${pathname}`;
          const isLogin = routes.login === pathname?.match(/^\/login/)?.[0];
          if (isLogin && auth?.user_id) {
            window.history.replaceState({}, "", window.location.origin);
            props.history.replace(routes.dashboard);
            return null;
          }
          return auth.user_id ? (
            <Suspense fallback={rest.loader}>
              <Component {...props} />
            </Suspense>
          ) : urlName === DATA_DICTIONARY_NAME ? (
            <Redirect
              to={{
                pathname: routes.login,
                search: `?redirect=${routes.data_dictionary}`,
                state:
                  urlDeepLink !== undefined ? { data: urlDeepLink } : undefined,
              }}
            />
          ) : (
            <Redirect to={`${routes.login}${urlExtend}`} />
          );
        }
      }
    />
  );
}
export function PublicRoute({ component: Component, ...rest }) {
  /* istanbul ignore next */
  const auth = getLSAuth();
  /* istanbul ignore next */
  return (
    <Route
      {...rest}
      render={
        /* istanbul ignore next */ (props) =>
          !auth.user_id ? (
            <Suspense fallback={rest.loader}>
              <Component {...props} />
            </Suspense>
          ) : (
            <Redirect
              to={{
                pathname: routes.dashboard,
                state: { from: props.location },
              }}
            />
          )
      }
    />
  );
}
